import React, { Fragment, useRef } from "react";
import _ from "lodash";

import CpapTrialRegisterFields from "./CpapTrialRegisterFields";
import cpapTrialTicketFields from "./cpapTrialTicketFields";

export const CpapTrialTicketEditForm = (props) => {
  const inputRef = useRef({});

  const renderFields = () => {
    return _.map(
      cpapTrialTicketFields,
      ({ label, name, type, options, required, disabled, description }) => {
        return (
          <CpapTrialRegisterFields
            name={name}
            label={label}
            type={type}
            value={inputRef.current[name]}
            fileNames={props.fileNames}
            defaultfiles={props.defaultfiles}
            options={options}
            required={required}
            initailValue={
              props.initailValues ? props.initailValues[name] : null
            }
            onChange={props.onChange(name)}
            disabled={disabled}
            description={description}
            product={props.product}
            onViewFile={props.onViewFile}
            ticketId={props.ticketId}
            onProductFound={props.onProductFound}
          />
        );
      }
    );
  };

  return <Fragment>{renderFields()}</Fragment>;
};
